import { useT } from '../../i18n';
import { selectStation, useAppStore } from '../../store/useAppStore';
import { Dialog } from '../../ui/Dialog';
import { VignetteInhalt } from './VignetteInhalt';
import styles from './Sheets.module.css';

/** Die Fallvignette der Station: Auftrag an den Prüfling, Nachschlagewerk für den Prüfer. */
export function VignetteDialog() {
  const t = useT();
  const station = useAppStore(selectStation);
  const closeSheet = useAppStore((s) => s.closeSheet);
  const examId = useAppStore((s) => s.examId);
  const vignette = station.vignette;
  const medien = station.medien ?? [];

  // Material ohne Vignette ist selten, aber möglich — dann wäre der Dialog der einzige Ort,
  // an dem es sichtbar würde. Deshalb hier nicht allein an der Vignette entscheiden.
  if (!vignette && medien.length === 0) return null;

  return (
    <Dialog kicker={t.bogen.vignette} title={station.label} onClose={closeSheet} width={640}>
      <div className={`sc ${styles.vignetteBody}`}>
        <VignetteInhalt vignette={vignette} medien={medien} examId={examId} />
      </div>
    </Dialog>
  );
}
